<div class="metric-card" style="height: 100%; width: 100%; margin-right: 1%">
  <div
    class="d-flex justify-content-between align-items-center pb-3 mb-3 chart-header-border"
  >
    <div class="d-flex align-items-center">
      <div class="chart-icon-container me-3 insight-icon">
        <i class="bi bi-pie-chart"></i>
      </div>
      <h3 class="chart-title mb-0">Total Cost Contribution</h3>
    </div>
  </div>

  <div class="bar-chart flex-grow-1 position-relative">
    <canvas
      baseChart
      [data]="donutData"
      [options]="donutOptions"
      [type]="'doughnut'"
      style="
        position: absolute;
        top: 0;
        left: 0;
        width: 100% !important;
        height: 100% !important;
      "
    ></canvas>
  </div>

  <div
    class="chart-footer d-flex justify-content-between align-items-center px-2 py-0"
  >
    <div class="ms-auto d-flex align-items-center">
      <strong class="text-secondary me-2">Total Cost of Goods Produced:</strong>
      <span class="text-dark fs-5 fw-bold">
        R{{ grandTotal | number : "1.2-2" }}
      </span>
    </div>
  </div>
</div>
